import { coursesNameDropdownModel } from '@/pages/common/dropdowns/multiselectDropdown/courses-name-dropdown-filter/courses-filter-dropdown.model'
import { groupsDropdownModel } from '@/pages/common/dropdowns/multiselectDropdown/groups-dropdown-filter/groupsFilterDropdown.model'
import { lessonsDropdownModel } from '@/pages/common/dropdowns/multiselectDropdown/lessons-dropdown-filter/lessons-filter-dropdown.model'

export const dropdownModules = {
  coursesNameDropdownModel,
  groupsDropdownModel,
  lessonsDropdownModel,
}
